import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attribute-editor',
  templateUrl: './attribute-editor.component.html',
  styleUrls: ['./attribute-editor.component.scss']
})
export class AttributeEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
